module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appendices"
  }, [_c('h1', {
    attrs: {
      "id": "appendices"
    }
  }, [_vm._v("APPENDICES")]), _vm._v(" "), _c('table', {
    staticClass: "indicator-1"
  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._l((_vm.years([1.1])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([1.1])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([1.1])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.rows([1.1])[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.1])[0].data), function(row, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.2], 'Female')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.2], 'Female')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.2], 'Male')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.2], 'Male')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.2], 'Other')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.2], 'Other')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '< 30')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '< 30')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '30–39')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '30–39')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '40–49')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '40–49')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '≥ 50')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '≥ 50')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          POC Tests\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.4])[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.healthAuthorities[_vm.ha].hsda), function(hsda) {
    return [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            " + _vm._s(hsda.name || hsda) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([1.5], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "left-padded",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            Female\n          ")]), _vm._v(" "), _vm._l((_vm.rows([1.6], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "left-padded",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            Male\n          ")]), _vm._v(" "), _vm._l((_vm.rows([1.7], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-2"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._l((_vm.years(2.1)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(year) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.rows([2.1])), function(serie) {
    return _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n          " + _vm._s(serie.name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.1], serie.name)[0].data), function(col) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n          " + _vm._s(col) + "\n        ")])
    })], 2)
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.2], 'Female')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.2], 'Female')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.2], 'Male')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.2], 'Male')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '< 30')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '< 30')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '30–39')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '30–39')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '40–49')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '40–49')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '≥ 50')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '≥ 50')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2)], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-3"
  }, [_c('tbody', [_c('tr', [_vm._m(2), _vm._v(" "), _vm._l((_vm.years([3.1])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([3.1])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([3.1])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.healthAuthorities[_vm.ha].name) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          By Client Residence\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.1], _vm.healthAuthorities[_vm.ha].name)[0].data), function(row, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('td', [_vm._v("\n          By Provider Address\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.1], 'By Provider Address')[0].data), function(row, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.2], 'Female')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.2], 'Female')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.2], 'Male')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.2], 'Male')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '< 30')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '< 30')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '30–39')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '30–39')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '40–49')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '40–49')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '≥ 50')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '≥ 50')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("\n          Exposure\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'MSM')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'MSM')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'PWID')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'PWID')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'HET')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'HET')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'Other')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'Other')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'NIR/Unknown')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'NIR/Unknown')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.healthAuthorities[_vm.ha].hsda), function(hsda) {
    return [_c('tr', [_c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("\n            " + _vm._s(hsda.name || hsda) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            By Client Residence\n          ")]), _vm._v(" "), _vm._l((_vm.rows([3.5], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(row).toFixed(0)) + "\n          ")])
    })], 2), _vm._v(" "), _c('tr', {
      staticStyle: {
        "font-style": "italic"
      }
    }, [_c('td', [_vm._v("\n            By Provider Address\n          ")]), _vm._v(" "), _vm._l((_vm.rows([3.5], 'By Provider Address', _vm.rows([3.5], hsda.name || hsda)[0].color)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(row).toFixed(0)) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-4"
  }, [_c('tbody', [_vm._m(3), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.healthAuthorities[_vm.ha].name) + "\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Female\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Male\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          < 30 years\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          30-39 years\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          40-49 years\n        ")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.years(4.1)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.2)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.3).slice(0, -5)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.rows([4.1])), function(serie) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(serie.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([4.1], serie.name)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    }), _vm._v(" "), _vm._l((_vm.rows([4.3], serie.name)[0].data.slice(0, 15)), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.years(4.1)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.2)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.3).slice(0, -5)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.rows([4.1])), function(serie) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(serie.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([4.3], serie.name)[0].data.slice(-30)), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-5"
  }, [_c('tbody', [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.healthAuthorities[_vm.ha].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.1], 'Overall HA')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Men\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.2], 'Men')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Women\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.2], 'Women')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age Category\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '< 30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          30–39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '30–39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          40–49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '40–49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '≥ 50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n          MSM Status\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          MSM\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.4], 'MSM')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Non-MSM\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.4], 'Non-MSM')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Unknown\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.4], 'Unknown')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "12"
    }
  }, [_vm._v("\n          Age Category and MSM Status\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          MSM\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:<30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          30-39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:30-39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          40-49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:40-49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:>=50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Non-MSM\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:<30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          30-39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:30-39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          40-49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:40-49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:>=50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Unknown\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:<30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          30-39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:30-39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          40-49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:40-49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:>=50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n          PWID Status\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          PWID\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.6], 'IDU')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Non-PWID\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.6], 'Non-IDU')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Unknown\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.6], 'Unknown')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.healthAuthorities[_vm.ha].hsda), function(hsda, index) {
    return [_c('tr', [(index === 0) ? _c('td', {
      attrs: {
        "rowspan": _vm.healthAuthorities[_vm.ha].hsda.length
      }
    }, [_vm._v("\n            " + _vm._s(_vm.ha === 'bc' ? 'Health Authority' : 'HSDA') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            " + _vm._s(hsda.name || hsda) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([5.7], hsda.name || hsda)), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(value) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-6"
  }, [_c('tbody', [_c('tr', [_vm._m(6), _vm._v(" "), _vm._l((_vm.years([6.1])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([6.1])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([6.1])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator6), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows(row.figure, row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(index <= 5 ? 1 : 0)) + _vm._s(index <= 5 ? '%' : '') + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.years([7])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([7])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([7])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator7), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([7], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.years([8])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([8])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([8])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator8), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([8], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(9), _vm._v(" "), _vm._l((_vm.years([9])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([9])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([9])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator9), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([9], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.years([10])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([10])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([10])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator10), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([10], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.years([11])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([11])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([11])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator11), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([11], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-12"
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.years(12)), function(year) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(year) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          CD4 < 200 at ART initiation\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          Cases\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'CD4<200 at ART Initiation (CASES)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('td', [_vm._v("\n          Rate per 100,000\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'CD4<200 at ART Initiation (PER 100K)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(1)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          AIDS Cases (DTP Reports)\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          Cases\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: DTP Reports (CASES)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('td', [_vm._v("\n          Rate per 100,000\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: DTP Reports (PER 100K)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(1)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          AIDS Cases (BCCDC Reports)\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          Cases\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: BCCDC Reports (CASES)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\n          Rate per 100,000\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: BCCDC Reports (PER 100K)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(1)) + "\n        ")])
  })], 2)])]), _vm._v(" "), _c('table', {
    staticClass: "indicator-13",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.years(13)), function(year) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(year) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          British Columbia\n        ")]), _vm._v(" "), _vm._l((_vm.rows([13]).find(function(e) {
    return e.table.title === 'HIV-Related Deaths'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Per 100 HIV+ Population\n        ")]), _vm._v(" "), _vm._l((_vm.rows([13]).find(function(e) {
    return e.table.title === 'Per 100 HIV+ Population'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(2)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Per 100,000 Population\n        ")]), _vm._v(" "), _vm._l((_vm.rows([13]).find(function(e) {
    return e.table.title === 'Per 100,000 Population'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(2)) + "\n        ")])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 1: "), _c('b', [_vm._v("Test Episodes (thousands)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 2: "), _c('b', [_vm._v("Rate of HIV Testing per 100,000")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 3: "), _c('b', [_vm._v("New HIV Diagnoses")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "31"
    }
  }, [_vm._v("\n          Indicator 4: "), _c('b', [_vm._v("Stage of HIV Infection at Baseline")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('td', {
    staticClass: "bottom-aligned"
  }), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          ≥ 50 years\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          MSM\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Heterosexual\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          PWID\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Other Exposure\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          NIR/Unknown\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          Indicator 5: "), _c('b', [_vm._v("HIV Cascade of Care")])]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Diagnosed\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Linked\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Retained\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          On ARVs\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Adherent\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Suppressed\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 6: "), _c('b', [_vm._v("Programmatic Compliance Score (PCS)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 7: "), _c('b', [_vm._v("New DTP ARV Participants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 8: "), _c('b', [_vm._v("CD4 Cell Count Initiation for ARV-Naïve DTP Participants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 9: "), _c('b', [_vm._v("Active and Inactive DTP Participants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 10: "), _c('b', [_vm._v("Antiretroviral Adherence")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 11: "), _c('b', [_vm._v("Resistance Testing and Results")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 12: "), _c('b', [_vm._v("AIDS-Defining Illness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned"
  }, [_vm._v("\n          Indicator 13: "), _c('b', [_vm._v("HIV-Related Mortality")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aec54c0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/Appendices.vue
// module id = 136
// module chunks = 0